var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormFieldRadioGroup',{attrs:{"checked":_vm.selectedUnitId,"label":_vm.$t('Einheit'),"variant":"vertical","options":_vm.unitValues},on:{"change":_vm.updateUnit}})
}
var staticRenderFns = []

export { render, staticRenderFns }